import React from 'react';
import { useError } from './ErrorContext';
import Modal from '../components/Modal/Modal';
import alert from './alert';
import Button from '../components/Button/Button';
import { isConnectionError } from './isConnectionError';
export const generateCurlCommand = (error) => {
  if (!error?.config) return 'Unable to generate cURL command.';

  const { method, url, headers, data } = error.config;
  const formattedHeaders = Object.entries(headers || {})
    .map(([key, value]) => `-H "${key}: ${value}"`)
    .join(' ');

  const dataPart = data ? `-d '${JSON.stringify(data)}'` : '';

  return `curl -X ${method?.toUpperCase()} "${url}" ${formattedHeaders} ${dataPart}`;
};

export const copyToClipboard = (text) => {
  navigator.clipboard.writeText(text).then(
    () => alert.success('Ошибка скопирована в буфер обмена'),
    (err) => alert.error('Ошибка при копировании ошибки: ', err)
  );
};

const GlobalErrorModal = () => {
  const { error, hideError } = useError();
  const [showDetails, setShowDetails] = React.useState(false);

  if (!error) return null;

  // Менеджеру бесполезен стек AxiosError и номера модулей webpack: он не может
  // по ним ничего сделать. Говорим, что происходит и что делать, а технические
  // подробности прячем — разработчику они остаются в один клик.
  const connectionError = isConnectionError(error);

  const handleCopyCurl = () => {
    const curlCommand = generateCurlCommand(error);
    copyToClipboard(curlCommand);
  };

  const handleCopyError = () => {
    const errorInfo = JSON.stringify(error, null, 2);
    copyToClipboard(errorInfo);
  };

  return (
    <Modal
      isOpen={!!error}
      title={connectionError ? 'Сервер сейчас недоступен' : 'Произошла ошибка'}
      onRequestClose={hideError}
      contentStyle={{
        maxHeight: 400,
        maxWidth: 600,
      }}
    >
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        height: '100%',
      }}>
        <div style={{
          maxHeight: 200,
          overflow: 'auto',
          padding: 20,
          marginBottom: 20,
        }}>
          {connectionError ? (
            <>
              <p>
                Не удалось связаться с сервером. Обычно это значит, что идёт обновление
                системы — оно занимает меньше минуты.
              </p>
              <p style={{ marginTop: 10 }}>
                Подождите минуту и повторите действие. Введённые данные не потеряются.
                Если ошибка повторяется дольше пяти минут — сообщите разработчикам.
              </p>
            </>
          ) : (
            <p>{error.message}</p>
          )}
          {error.details && showDetails && (
            <pre style={{ whiteSpace: 'pre-wrap' }}>{JSON.stringify(error.details, null, 2)}</pre>
          )}
          {!showDetails && (
            <p
              onClick={() => setShowDetails(true)}
              style={{ marginTop: 15, color: '#8E8E93', cursor: 'pointer', fontSize: 14 }}
            >
              Подробности для разработчика
            </p>
          )}
        </div>
        <div style={{
          gap: 20,
          display: 'flex',
          marginTop: 'auto'
        }}>
          <Button fill onClick={handleCopyCurl}>Скопировать cURL</Button>
          <Button fill onClick={handleCopyError}>Скопировать текст ошибки</Button>
        </div>
      </div>
    </Modal>
  );
};

export default GlobalErrorModal;
